import useGetWhiteLabelLogo from "@/features/white-label-logo/useGetWhiteLabelLogo";
import { isKashuApp } from "@/lib/utils";
import { useLoaderData } from "@tanstack/react-router";
import { useEffect } from "react";

function LocationSettingsSetup() {
	const { primary_color, logo, name } = useLoaderData({ from: "__root__" });
	const { data: logoSrc } = useGetWhiteLabelLogo({ logoPath: logo });

	useEffect(() => {
		// Update document title
		document.title = name;

		if (isKashuApp()) {
			// if the app is kashu we only need to update the theme color meta tag
			// Favicon is stored locally in the codebase for performance reasons.

			const primaryColor = getComputedStyle(document.documentElement)
				.getPropertyValue("--primary-600")
				.trim();
			const meta = document.createElement("meta");
			meta.name = "theme-color";
			meta.content = primaryColor;
			document.head.appendChild(meta);
			return;
		}
		const meta = document.createElement("meta");
		meta.name = "theme-color";
		meta.content = primary_color;
		document.head.appendChild(meta);

		/* if (logoSrc) {
			const existingFavicon = document.querySelector('link[rel="icon"]');
			if (existingFavicon) {
				existingFavicon.setAttribute("href", logoSrc);
			} else {
				const link = document.createElement("link");
				link.rel = "icon";
				link.type = "image/svg+xml";
				link.href = logoSrc;
				document.head.appendChild(link);
			}
		} */
	}, [logoSrc, primary_color, name]);

	return null;
}

export default LocationSettingsSetup;
